/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Add, Settings, Visibility } from '@mui/icons-material';
import { Box, Button, Divider, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';

import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CustomAlert } from '../../shared';

import DialogSecao from './DialogSecao';
import { ServiceSecao } from '../../../services/api/secao/ServiceSecao';
import GraficoSecao from './GraficoSecao';
import { ReadingServices } from '../../../services/api/reading/ReadingServices';
import { ModalConfigGrafico } from './DialogConfigSecao';
import { ModalData } from './ModalData';
import { useAuthContext } from '../../../context';
import { AxiosError } from 'axios';

interface PlanAndSectionsProps {
	uuid: string;
}

function formatMessage(message: string){
	if(message.includes('elevacao_terreno')){
		return message.replace('elevacao_terreno', 'Elevação do Terreno');
	}
	return message;
}

export const PlanAndSections: React.FC<PlanAndSectionsProps> = ({
	uuid,
}) => {

	const INITIAL_STATE = {
		id_barragem: uuid,
		data: '',
		descricao: '',
		x0: '',
		y0: '',
		x1: '',
		y1: '',
		arquivo: null,
	};

	const [dataSecao, setDataSecao] = useState<any>(INITIAL_STATE);

	const [open, setOpen] = useState<boolean>(false);
	const [grafico, setGrafico] = useState<any>(null);
	const [data, setData] = useState<any>([]);
	const [allGraficos, setAllGraficos] = useState<any>([]);
	const [openConfigModal, setOpenConfigModal] = useState<boolean>(false);
	const [openDataModal, setOpenDataModal] = useState<boolean>(false);
	const [graficoSelecionado, setGraficoSelecionado] = useState<string | null>(null);
	const { userData } = useAuthContext();
	const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info', key: string }>({
		open: false,
		message: '',
		severity: 'success',
		key: '',
	});

	const pagePermissionsString: string | undefined = useMemo(() => {
		return userData?.nivel_acesso?.acompanhamentos?.visualizacao;
	}, [userData]);

	const hasActionPermission = (action: 'add' | 'edit' | 'remove' | 'view'): boolean => {
		if (typeof pagePermissionsString === 'string' && pagePermissionsString !== '') {
			const actions = pagePermissionsString.split(',').map(s => s.trim());
			return actions.includes(action);
		}
		return false;
	};

	function dialogControl() {
		setOpen(!open);
	}

	function onChange(key: string, value: string) {
		setDataSecao((prevData: any) => ({
			...prevData,
			[key]: value,
		}));
	}

	const handleOpenConfigModal = (uuid: string) => {
		setOpenConfigModal(true);
	};

	const handleSubmitDataModal = (dataSelecionada: string) => {
		if (!graficoSelecionado) return;

		const dataFormatada = dataSelecionada.split('T')[0];
		getGrafico(graficoSelecionado, uuid, dataFormatada);
		setOpenDataModal(false);
	};

	const handleDataModal = (grafico: any) => {
		setGraficoSelecionado(grafico.uuid);
		if (grafico.posicoes === null || Object.keys(grafico.posicoes).length === 0) {
			const today = new Date();
			const year = today.getFullYear();
			const month = String(today.getMonth() + 1).padStart(2, '0');
			const day = String(today.getDate()).padStart(2, '0');
			const todayFormatted = `${year}-${month}-${day}`;
			getGrafico(grafico.uuid, uuid, todayFormatted);
		} else {
			setOpenDataModal(true);
		}
	};

	const handleCloseConfigModal = () => {
		setOpenConfigModal(false);
	};

	const handleSubmitConfig = async (configData: Record<string, number>) => {
		if (!graficoSelecionado) return;

		try {
			const response = await ServiceSecao.confGrafico(graficoSelecionado, configData);
			if (response instanceof Error) {
				setAlertInfo({ open: true, message: 'Erro ao cadastrar configurações', severity: 'error', key: new Date().toISOString() });
			} else {
				setAlertInfo({ open: true, message: 'Configuração salva com sucesso', severity: 'success', key: new Date().toISOString() });
				getAll(uuid);
			}
		} catch (error) {
			setAlertInfo({ open: true, message: 'Erro ao cadastrar configurações', severity: 'error', key: new Date().toISOString() });
		} finally {
			handleCloseConfigModal();
		}
	};

	const onSecaoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (e.target.files && e.target.files.length > 0) {
			const selectedFile = e.target.files[0];
			setDataSecao((prevData: any) => ({
				...prevData,
				arquivo: selectedFile,
			}));
		}
	};

	async function getAll(uuid: string) {
		const response = await ServiceSecao.getAll(uuid);
		if (response instanceof Error) {
			setAlertInfo({ open: true, message: 'Sem seções existentes', severity: 'warning', key: new Date().toISOString() });
		} else {
			setAllGraficos(response);
		}
	}

	async function create() {
		try {
			const response = await ServiceSecao.create(uuid, dataSecao);

			if (response && response.error) {
				setAlertInfo({ open: true, message: `Erro ao criar seção: ${response.message}`, severity: 'error', key: new Date().toISOString() });
			} else {
				setAlertInfo({ open: true, message: 'Seção criada com sucesso', severity: 'success', key: new Date().toISOString() });
				setOpen(false);
				setDataSecao(INITIAL_STATE);
				getAll(uuid);
			}
		} catch (error: any) {
			setAlertInfo({ open: true, message: `Erro de comunicação: ${error.message}`, severity: 'error', key: new Date().toISOString() });
		}
	}

	async function getGrafico(id_planta: string, uuid: string, data: string) {
		const response = await ServiceSecao.get(data, uuid, id_planta);
		
		if (response instanceof AxiosError) {	
			
			setAlertInfo({
				open: true,
				message: formatMessage(response.response?.data?.message.message) || 'Erro ao obter gráfico',
				severity: 'error',
				key: new Date().toISOString(),
			});

			return;
		}

		setGrafico(response);
	}

	async function fetchData(uuid: string) {
		const response = await ReadingServices.getAll(uuid);
		if (response instanceof Error) {
			setAlertInfo({ open: true, message: 'Erro ao obter dados de instrumentos', severity: 'error', key: new Date().toISOString() });
		} else {
			const dadosSemUltimo = response.slice(0, -1);
			const instrumentosCota = dadosSemUltimo.filter(instr =>
				['piezometro', 'indicador', 'regua'].includes(instr.tipo_instrumento)
			);
			setData(instrumentosCota);
		}
	}

	useEffect(() => {
		fetchData(uuid);
		getAll(uuid);
	}, [uuid]);

	return (
		<Box>
			<Box>
				{hasActionPermission('add') && (
					<Button
						variant='contained'
						sx={{ borderRadius: '25px', paddingY: 1, mb: 2 }}
						onClick={dialogControl} startIcon={<Add />}>
						Nova Seção
					</Button>
				)}
			</Box>
			<Divider sx={{ mb: 2 }} />
			<Box mb={4}>
				<Typography variant="h6" gutterBottom>
					Gráficos Disponíveis
				</Typography>
				<TableContainer component={Paper}>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell>Descrição</TableCell>
								<TableCell align="right">Ações</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{allGraficos.map((grafico: any) => (
								<TableRow key={grafico.uuid}>
									<TableCell>
										{grafico.descricao || 'Sem descrição'}
									</TableCell>
									<TableCell align="right">
										{hasActionPermission('view') && (
											<Button
												variant="outlined"
												startIcon={<Visibility />}
												onClick={() => handleDataModal(grafico)}
											>
												Visualizar
											</Button>
										)}
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			</Box>
			<Box mt={4}>
				{grafico !== null ? (
					<>
						<Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
							<Typography variant="h6">Gráfico Selecionado</Typography>
							<Button
								variant="contained"
								startIcon={<Settings />}
								onClick={() => handleOpenConfigModal(grafico.uuid)}
							>
								Configurar Gráfico
							</Button>
						</Box>
						<GraficoSecao dta={grafico} />
					</>
				) : (
					<Typography variant="body1" color="textSecondary">
						Selecione um gráfico para visualização
					</Typography>
				)}
			</Box>
			<DialogSecao
				data={dataSecao}
				onChange={onChange}
				onChangeSecao={onSecaoChange}
				onClose={dialogControl}
				open={open}
				onSave={create}
			/>

			<ModalConfigGrafico
				open={openConfigModal}
				onClose={handleCloseConfigModal}
				onSubmit={handleSubmitConfig}
				instrumentos={data.map((item: any) => ({
					uuid: item.uuid,
					nome: item.nome || `Instrumento ${item.uuid.slice(0, 5)}`,
					tipo_instrumento: item.tipo_instrumento
				}))}
			/>

			<ModalData
				open={openDataModal}
				onClose={() => setOpenDataModal(false)}
				onSubmit={handleSubmitDataModal}
			/>
			{alertInfo.open && (
				<CustomAlert
					message={alertInfo.message}
					severity={alertInfo.severity}
					key={alertInfo.key}
				/>
			)}
		</Box >
	);
};